import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Loading } from "../../../components/Loading/Loading";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { FooterButtonSigleCustom } from "../../../components/FooterButton/FooterButton";

//SERVICE
import { pSupervisorWarningLetterList } from "../../../service/200/P216Service";

//PAGE
import P216List from "./P216List";

export default function P110() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    const [requestSrh, setRequestSrh] = useState({ contractorName: "", contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "" });

    //Data
    const [dataTable, setDataTable] = useState([]);
    const [dataForm, setDataForm] = useState({ contractorCode: "", contractorName: "", contractNo: "", routeNo: "" });

    // Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setRequestSrh({
                    contractNo: history.location.state.contractNo,
                    contractorName: history.location.state.contractorName,
                    userId: dataUserSession().userId,
                });
                setDataForm({ ...dataForm, routeNo: history.location.state.routeNo });
            } else {
                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);
    useEffect(() => {
        if (requestSrh.contractorName !== "") onGetSupervisorWarningLetterList();
    }, [requestSrh]);

    const onGetSupervisorWarningLetterList = () => {
        setLoading(true);
        pSupervisorWarningLetterList(requestSrh).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                    setDataForm({ ...dataForm, ...temp[0] });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }

                setLoading(false);
            }
        );
    };
    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setDataForm({
            ...dataForm,
            [`${key}`]: val,
        });
    };

    const footerButtonSingle = () => {
        const con = () => {
            // alert("/200");
            // history.push("/200");
            setConfirmDialog(false);
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };

    const handlerGoPage = (obj) => {
        switch (obj.go) {
            case "/208":
                history.push("/208");
                break;
            case "EDIT":
                obj.data["routeNo"] = dataForm.routeNo;
                obj.data["action"] = "OPEN";
                history.push({
                    pathname: "/216Edit",
                    state: {
                        dataObject: {
                            ...obj,
                        },
                    },
                });
                break;

            case "NEW":
                history.push({
                    pathname: "/216Edit",
                    state: {
                        dataObject: {
                            data: {
                                go: obj.go,
                                warningNo: dataForm.nextWarningNo,
                                routeNo: dataForm.routeNo,
                                contractNo: requestSrh.contractNo,
                                contractorName: requestSrh.contractorName,
                            },
                        },
                    },
                });
                break;

            default:
                break;
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ใบแจ้งเตือน</h2>
                        <hr /> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractNo" value={requestSrh.contractNo} onChange={(e) => onInputTextChange(e, "contractNo")} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ชื่อบริษัท</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractorName" value={requestSrh.contractorName} onChange={(e) => onInputTextChange(e, "contractorName")} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <P216List dataTable={dataTable} dis={false} goPage={handlerGoPage} />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerGoPage({ go: "/208" })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
